/* @flow */

import ProgressPromise from './progress_promise'
import { support, consumed, readBlobAsArrayBuffer, readBlobAsText, decode } from './helpers'

class Body {
  bodyUsed: boolean
  blob: (void) => ProgressPromise
  _bodyText: string
  arrayBuffer: any
  text: (any) => ProgressPromise
  formData: (any) => ProgressPromise
  json: (any) => ProgressPromise
  _bodyInit: ?FormData | ?Blob | ?string
  _bodyBlob: ?Blob
  _bodyFormData: ?FormData

  constructor() {
    this.bodyUsed = false
    if (support.blob) {
      this.blob = () => {
        const rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return ProgressPromise.resolve(this._bodyBlob)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return ProgressPromise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = () => {
        return this.blob().then(readBlobAsArrayBuffer)
      }

      this.text = () => {
        const rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text')
        } else {
          return ProgressPromise.resolve(this._bodyText)
        }
      }
    } else {
      this.text = () => {
        const rejected = consumed(this)
        return rejected ? rejected : ProgressPromise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = () => {
        return this.text().then(decode)
      }
    }

    this.json = () => {
      return this.text().then((text) => {
        return JSON.parse(text)
      })
    }
  }

  _initBody(body: ?FormData | ?Blob | ?string) {
    this._bodyInit = body
    if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && body instanceof Blob) {
      this._bodyBlob = body
    } else if (support.formData && body instanceof FormData) {
      this._bodyFormData = body
    } else if (!body) {
      this._bodyText = ''
    } else {
      throw new Error('unsupported BodyInit type')
    }
  }
}

export default Body
